import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import PageHeader from "../../components/PageHeader/PageHeader";
import InputField from "../../components/InputField/InputField";
import setInputValues from "../../utils/helpers/setInputValue";
import { useLocation, useNavigate } from "react-router-dom";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { useAppDispatch } from "../../store/storeRequests";
import CroppingModal from "../../components/Cropping Modal/CroppingModal";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { Group } from "../../utils/constants/Interfaces.constants";
import CustomButton from "../../components/CustomButton/CustomButton";
import Select from "react-select";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";
import CustomDatePicker from "../../components/CustomDatePicker/CustomDatePicker";
import formatDate from "../../utils/helpers/formatDate";
import encrypt from "../../utils/helpers/encrypt";
import { validateImageFile } from "../../utils/helpers/validateFileUpload";
import TextArea from "../../components/TextArea/TextArea";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import { ArrowLeftSquareFill } from "react-bootstrap-icons";
import { customStyles, customSingleSelectStyles} from "../../utils/constants/CustomStyles.constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, parseISO } from "date-fns";
import "./survey.scss";
import subtractFiveHoursThirtyMinutes from "../../utils/helpers/subtractFiveHoursThirtyMinutes";

interface SurveyInfo {
  id?: number;
  name: string;
  type: string | "Url" | "Quiz";
  url: string;
  description: string;
  group: number[];
  closeDate: string;
  is_priority: 0 | 1;
  is_group:number;
}

const surveyTypes = [
  {
    id: 1,
    label: "URL",  
    value: "Url",  
  },
  {
    id: 2,
    label: "Quiz",  
    value: "Quiz", 
  },
];
const SurveyForm = () => {
  const cmpMounted = useRef(false);
  const navigate = useNavigate();
  const [surveyName , setSurveyName] = useState("");
  const [surveyUrl , setSurveyUrl] = useState("");
  const [surveyInfo, setSurveyInfo] = useState<SurveyInfo>({
    name: "",
    type: "Url",
    url: "",
    description: "",
    group: [],
    closeDate: "",
    is_priority: 0,
    is_group:1
  });
  const [initialFormState, setInitialFormState] = useState<SurveyInfo | null>(
    null
  );
  const dispatch = useAppDispatch();
  const [groupData, setGroupData] = useState<any>([]);
  const [selectedValue, setSelectedValue] = useState<any>([]);
  const [currentValue, setCurrentValue] = useState(surveyTypes[0]);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [isPriority, setIsPriority] = useState(false);
  const [folderImage, setFolderImage] = useState<{ value: any; src: string }>({
    value: null,
    src: "",
  });
  const [showCroppingModal, setShowCroppingModal] = useState(false);
  const [imageChanged, setImageChanged] = useState(false);
  const isImageChanged = useRef(false)
  const [groupError, setGroupError] = useState("");
  const [dateTime, setDateTime] = useState<string>("");
  // const [error, setError] = useState<string | null>(null);
  const [dobError, setDobError] = useState("")
  // const [menuIsOpen, setMenuIsOpen] = useState(true);
  const [menuKey, setMenuKey] = useState(Date.now());

  const location = useLocation();
  const isEdit = location.state?.isEdit;  

  const selectAllOption = { value: 'select_all', label: 'Select All' };
  
  const options = groupData.map((item: any) => ({
    value: item.id,
    label: item.name,
  }));

  const [dropdownChoice, setDropdownChoice] = React.useState("1");
  // const allOptions = [
  //   { value: "select_all", label: "Select All" },
  //   {selectAllOption, ...options},
  //   // Add more options as needed
  // ];
  const [allOptions, setAllOptions] = useState<any>([]);
  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    fetchGroup();

    if (isEdit) {
      const { data } = location.state;
      if (data) {
        handleGetGroupById(data);
        const {
          id,
          name,
          type,
          url,
          description,
          closeDate,
          is_priority,
          surveyImage,
          is_group,
          group
        } = data;
        
        // const parsedClosedDate = new Date(closeDate);

        setSurveyInfo({
          id,
          name,
          type,
          url,
          description: description || "",
          group: is_group === 1 ? group : [], 
          // closeDate: formatDateTime(parsedClosedDate),
          closeDate: formatISODate(closeDate),
          is_priority,
          is_group,
          
        });

        console.log("SURVEY INFO", id,
          name,
          type,
          url,
          description,
         closeDate,
          is_priority,
);
        

        setInitialFormState({
          id,
          name,
          type,
          url,
          description: description || "",
          group: [],
          // closeDate: formatDateTime(parsedClosedDate),
          closeDate: formatISODate(closeDate),
          is_priority,

          is_group:1
        });

        // console.log("Close Date", closeDate);
        // console.log("Parsed Close Date", subtractFiveHoursThirtyMinutes(convertISOToUTCDate(closeDate)));
        
         
        setSurveyName(name);
        setSurveyUrl(url);
        setSelectedDate(subtractFiveHoursThirtyMinutes(convertISOToUTCDate(closeDate)));
        setCurrentValue(type === "Url" ? surveyTypes[0] : surveyTypes[1]);
        setIsPriority(is_priority === 1);
        setFolderImage({ ...folderImage, src: surveyImage || "" });
        setDateTime(getCurrentDateTime(new Date(closeDate)));
        setDropdownChoice(`${is_group}`);
        // setSelectedValue(selectedValue)
      }
    }
  }, [isEdit, location.state]);

  // const fetchGroup = async () => {
  //   try {
  //     dispatch(showLoader("Loading data..."));
  //     const response = await postDetails(APIList.GET_ALL_GROUP, {});
  //     const activeGroups = response.data.filter(
  //       (item: Group) => item.status === 1
  //     );
  //     // console.log("Active Groups", activeGroups);
  //     setGroupData(activeGroups);
  //   } catch (error) {
  //     console.log("Error Fetching Groups", error);
  //     dispatch(showToast(`Some error occurred while fetching groups`));
  //       setTimeout(() => dispatch(hideToast()), 3000);
  //   } finally {
  //     dispatch(hideLoader());
  //   }
  // };

  const fetchGroup = async () => {
    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(APIList.GET_ALL_GROUP, {}); // Call your API
      const activeGroups = response.data.filter((item: any) => item.status === 1);
      setGroupData(activeGroups);

      // Prepare options for dropdown
      const dropdownOptions = [
        { value: "select_all", label: "Select All" },
        ...activeGroups.map((group: any) => ({
          value: group.id,
          label: group.name,
        })),
      ];
      setAllOptions(dropdownOptions);
    } catch (error) {
      console.error("Error Fetching Groups", error);
      dispatch(showToast(`Some error occurred while fetching groups`));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };
  const handleGetGroupById = async (item: any) => {
    // console.log("Survey ID", item.id);
    try {
      const response = await postDetails(APIList.GET_SURVEY_GROUP_DATA, {
        id: item.id,
      });
      // console.log("Survey group data", response);
      if (Array.isArray(response.data) && response.data.length !== 0) {
        const existingGroups = response.data.map((item: any) => ({
          value: item.groupId,
          label: item.groupName,
        }));
        setSelectedValue(existingGroups);
        const group_ids = response.data.map((item: any) => item.groupId);
        setSurveyInfo((prevValue: any) => ({ ...prevValue, group: group_ids }));
        setInitialFormState((prevValue: any) => ({
          ...prevValue,
          group: group_ids,
        }));
      }
    } catch (error) {
      console.log("Cannot get group details", error);
      dispatch(showToast(`Some occurred while fetching group details`));
        setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  function parseDateStringToUTC(isoString: string): Date {
    return parseISO(isoString); // This returns a Date object without time zone conversion
  }

  function convertISOToUTCDate(isoString: string): Date {
    const date = new Date(isoString);
  
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();  // 0-indexed (0 = January, 11 = December)
    const day = date.getUTCDate();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
  
    // Create a new Date object using the UTC components to prevent time zone conversion
    const utcDate = new Date(Date.UTC(year, month, day, hours, minutes, seconds));
    
    return utcDate;
  }

  // function subtractFiveHoursThirtyMinutes(date: Date): Date {
  //   // Convert 5 hours and 30 minutes to milliseconds
  //   const subtractTime = (5 * 60 * 60 * 1000) + (30 * 60 * 1000);
  
  //   // Subtract time from the date
  //   const updatedDate = new Date(date.getTime() - subtractTime);
  
  //   return updatedDate;
  // }

  const getCurrentDateTime = (date: Date): string => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
  };

  // const formatDateTime = (value: string): string => {
  //   // Convert the datetime-local format to "yyyy-mm-dd hh:mm:ss"
  //   const date = new Date(value);
  //   const yyyy = date.getFullYear();
  //   const mm = String(date.getMonth() + 1).padStart(2, '0');
  //   const dd = String(date.getDate()).padStart(2, '0');
  //   const hh = String(date.getHours()).padStart(2, '0');
  //   const min = String(date.getMinutes()).padStart(2, '0');
  //   const ss = String(date.getSeconds()).padStart(2, '0');

  //   return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
  // };

  const formatDateTime = (date: Date) => {
    return format(date, "yyyy-MM-dd HH:mm:ss");
  };

  function formatISODate(isoString: string, includeSeconds: boolean = false): string {
    const dateObj = new Date(isoString);
  
    // Extract date components
    const year = dateObj.getUTCFullYear();
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(dateObj.getUTCDate()).padStart(2, '0');
  
    // Extract time components
    const hours = String(dateObj.getUTCHours()).padStart(2, '0');
    const minutes = String(dateObj.getUTCMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getUTCSeconds()).padStart(2, '0');
  
    // Format date string
    const formattedDate = `${year}-${month}-${day}`;
  
    // Format time string, optionally include seconds
    const formattedTime = includeSeconds 
      ? `${hours}:${minutes}:${seconds}`
      : `${hours}:${minutes}`;
  
    return `${formattedDate} ${formattedTime}`;
  }

  // const validateUrl = (inputUrl: string): boolean => {
  //   try {
  //     const urlObject = new URL(inputUrl);
  //     return urlObject.protocol === "https:";
  //   } catch {
  //     return false;
  //   }
  // };

  // const validateUrl = (inputUrl: string): boolean => {
  //   try {
  //      const urlObject = new URL(inputUrl);

  //       // Allow only http:// or https://
  //       if (
  //         urlObject.protocol !== "http:" &&
  //         urlObject.protocol !== "https:"
  //       ) {
  //         return false;
  //       }

  //       // Require // after the protocol
  //       if (!/^https?:\/\//i.test(inputUrl)) {
  //         return false;
  //       }

  //       // Ensure a hostname exists
  //       if (!urlObject.hostname) {
  //         return false;
  //       }

  //       return true;
  //   } catch {
  //     return false;
  //   }
  // };

  const validateUrl = (inputUrl: string): boolean => {
    try {
      const value = inputUrl.trim();

      // If a protocol is provided, only allow http:// or https://
      if (/^[a-z][a-z\d+\-.]*:/i.test(value)) {
        if (!/^https?:\/\//i.test(value)) {
          return false;
        }
      }

      // Add https:// for protocol-less URLs
      const urlObject = new URL(
        /^https?:\/\//i.test(value) ? value : `https://${value}`
      );

      return (
        (urlObject.protocol === "http:" || urlObject.protocol === "https:") &&
        !!urlObject.hostname
      );
    } catch {
      return false;
    }
  };

  // const handleDateTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const selectedDate = event.target.value;
  //   console.log(selectedDate)
  //   setDateTime(selectedDate);

  //   const now = new Date();
  //   const selected = new Date(selectedDate);

  //   if (selected < now) {
  //     alert("Close Date cannot be earlier than today")
  //   }

  //   setSurveyInfo({
  //     ...surveyInfo,
  //     closeDate: formatDateTime(selectedDate)
  //   })

  // };

  const handleDateTimeChange = (date: Date | null) => {
    // if (!date) return;

    if(date){
    const now = new Date();

    // Check if selected date is earlier than today
    if (date < now) {
      dispatch(showToast(`Close date and time cannot be earlier than today`));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    setSelectedDate(date);

    // Set formatted date and time in state
    setSurveyInfo({
      ...surveyInfo,
      closeDate: formatDateTime(date),
    });
  } else{
    setSelectedDate(null);
  }
  };

  const handleSurveyNameChange = (
    ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    // const trimmedValue = ev.target.value.trim(); 
    setSurveyName(ev.target.value)
    setSurveyInfo({
      ...surveyInfo,
      name: ev.target.value.trim(),
    });
  };

  const handleSurveyURLChange = (
    ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSurveyUrl(ev.target.value)
    setSurveyInfo({
      ...surveyInfo,
      url: ev.target.value.trim(),
    });
  };

  const handleDescriptionChange = (
    ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSurveyInfo({
      ...surveyInfo,
      description: ev.target.value,
    });
  };

  // const handleMenuClose = (menuIsOpen: boolean) => {
  //   if (menuIsOpen && selectedValue.length === options.length) {
  //     // This will close the dropdown when all options are selected
  //     return false;
  //   }
  //   return true;
  // };


  const handleCoverImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;
    isImageChanged.current = true
    const validation = validateImageFile(file);
    if (!validation.valid) {
      dispatch(showToast(validation.message));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    const maxSize = 10.1 * 1024 * 1024;
    if (file.size > maxSize) {
      dispatch(showToast(`File size exceeds the 10MB limit. Please upload a smaller file.`));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    setFolderImage({
      value: file,
      src: URL.createObjectURL(file),
    });
    setShowCroppingModal(true);
    // setImageChanged(true);
  };

  const handleCrop = (croppedImage: string) => {
    setFolderImage((prev) => ({ ...prev, src: croppedImage }));
    setShowCroppingModal(false);
    setImageChanged(true);
  };

  const handleCancelCrop = () => {
    // Close the cropping modal without setting the image
    // setFolderImage({ value: null, src: "" }); // Reset the folder image
    setFolderImage((prev) => ({ ...prev, value: null, src: "" }));
    setShowCroppingModal(false); // Close the cropping modal
  };

  const removeImage = () => {
    setFolderImage({ value: null, src: "" });
  };

  // const handleSelectChange = (selectedOptions: any) => {
 

  //   if (!selectedOptions) {
  //     setSelectedValue([]);
  //     setSurveyInfo({ ...surveyInfo, group: [] });
  //     return;
  //   }

  //   const isSelectAllSelected = selectedOptions.some(
  //     (option: any) => option.value === 'select_all'
  //   );

  //   console.log("SELECTED OPTIONS LENGTH",selectedOptions.length)
  //   console.log("ALL OPTIONS LENGTH",allOptions.length)

  //   if (isSelectAllSelected) {
  //     if (selectedOptions.length === allOptions.length) {
  //       setSelectedValue([]);
  //       setSurveyInfo({ ...surveyInfo, group: [] });
  //     } else {
  //       setSelectedValue(allOptions.slice(1));
  //       const allGroupIds = options.map((option: any) => option.value);
  //       setSurveyInfo({ ...surveyInfo, group: allGroupIds });
  //       // setMenuIsOpen(false);
  //       setMenuKey(Date.now());

  //     }
  //   } else {
  //     // Normal selection
  //     setSelectedValue(selectedOptions);
  //     const groupIds = selectedOptions.map((item: any) => item.value);
  //     setSurveyInfo({ ...surveyInfo, group: groupIds });
  //     // setMenuIsOpen(true);

  //   }
  // };

  // const handleMenuOpen = () => {
  //   // Re-open the menu when there are unselected options
  //   if (selectedValue.length !== options.length) {
  //     setMenuIsOpen(true);
  //   }
  // };

  const handleSelectChange = (selectedOptions: any) => {
    if (!selectedOptions) {
      setSelectedValue([]);
      setSurveyInfo({ ...surveyInfo, group: [] });
      return;
    }

    const isSelectAllSelected = selectedOptions.some(
      (option: any) => option.value === "select_all"
    );

    if (isSelectAllSelected) {
      if (selectedOptions.length === allOptions.length) {
        setSelectedValue([]);
        setSurveyInfo({ ...surveyInfo, group: [] });
      } else {
        setSelectedValue(allOptions.slice(1));
        const allGroupIds = allOptions.slice(1).map((option: any) => option.value);
        setSurveyInfo({ ...surveyInfo, group: allGroupIds });
      }
    } else {
      setSelectedValue(selectedOptions);
      const groupIds = selectedOptions.map((item: any) => item.value);
      setSurveyInfo({ ...surveyInfo, group: groupIds });
    }
  };

  const handleDropdownChoiceChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setDropdownChoice(value);

    if (value === "0") {
      // All Employee selected
      setSurveyInfo({ ...surveyInfo, is_group: 0, group: [] });
      setSelectedValue([]);
    } else {
      // Group selected
      setSurveyInfo({ ...surveyInfo, is_group: 1 });
    }
  };
  const handleCheckBoxClick = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setIsPriority(ev.target.checked);
    setSurveyInfo({
      ...surveyInfo,
      is_priority: ev.target.checked ? 1 : 0,
    });
  };

  // const handleDropdownChange = (
  //   ev: any,
  //   item: { id: number; name: string; value: string }
  // ) => {
  //   setCurrentValue(item);
  //   setSurveyInfo({
  //     ...surveyInfo,
  //     type: item.value,
  //   });
  // };

  const handleDropdownChange = (selectedOption: any) => {
    setCurrentValue(selectedOption);
    setSurveyInfo({
      ...surveyInfo,
      type: selectedOption ? selectedOption.value : '', // Update type in surveyInfo
    });
  };

  const handleCancel = () => {
    // setSelectedValue(groupData[0]);
    setSurveyInfo({
      name: "",
      type: "Url",
      url: "",
      description: "",
      group: [],
      closeDate: "",
      is_priority: 0,
      is_group:0
    });

    navigate("/survey");
  };

  const handleSubmit = async (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    // console.log("Initial state", initialFormState);
    // console.log("After edit", surveyInfo);

    // if (JSON.stringify(surveyInfo) === JSON.stringify(initialFormState)) {
    //   dispatch(showToast(`No changes done`));
    //   setTimeout(() => dispatch(hideToast()), 3000);
    //   return;
    // }

    if(isEdit){
      if (!isImageChanged.current && (JSON.stringify(surveyInfo) === JSON.stringify(initialFormState))) {
        dispatch(showToast("No changes done."));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }
       }
       
       const now = new Date();

       // Check if selected date is earlier than today
       if (selectedDate && selectedDate < now) {
         dispatch(showToast(`Close date and time cannot be earlier than today`));
         setTimeout(() => dispatch(hideToast()), 3000);
         return;
       }

    setGroupError("");

    if (surveyInfo.type === "Url" && !validateUrl(surveyInfo.url)) {
      dispatch(showToast(`Invalid URL. Please enter a valid URL.`));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    // if (surveyInfo.group.length === 0) {
    //   dispatch(showToast(`Select atleast one group`));
    //   setTimeout(() => dispatch(hideToast()), 3000);
    //   setGroupError("Select Group");
    //   return;
    // }

    if (!isEdit && !imageChanged && !folderImage.value) {
      dispatch(showToast(`Please upload survey image`));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    if (!selectedDate) {
      setDobError("Please select close date and time.");
      dispatch(showToast(`Please select close date and time.`));
      setTimeout(() => dispatch(hideToast()), 3000);
      return; 
    }

    setDobError("");

    const formData = new FormData();

    // if (!isEdit) {
      formData.append("mediafiles", folderImage.value);
    // }
    formData.append("data", encrypt(surveyInfo));

    try {
      dispatch(showLoader("Submitting data..."));
      const response = await postMultipartDetails(APIList.ADD_SURVEY, formData);
      console.log(response);

      if(response.status === "Failed" || response.Status === "Failed"){
        dispatch(showToast(response.message));
        setTimeout(() => dispatch(hideToast()), 3000);
        return
      }

     else if (response.statusCode === 200) {
        dispatch(
          showToast(
            isEdit ? "Survey Updated Successfully" : "Survey Added Successfully"
          )
        );
        setTimeout(() => dispatch(hideToast()), 3000);
        navigate("/survey");

      } else {
        
        dispatch(showToast(`Some error occurred while submitting survey`));
        setTimeout(() => dispatch(hideToast()), 3000);
      }

    } catch (error) {
      console.log("Cannot submit survey.", error);
      dispatch(showToast(`Some error occurred while submitting the survey.`));
        setTimeout(() => dispatch(hideToast()), 3000);
        
    } finally{      
      dispatch(hideLoader());
    }
  };

  const buttons = [
    {
      label: "Back to Main List",
      theme: "warning",
      icon: <ArrowLeftSquareFill />,
      onClick: handleCancel,
    },
  ];

  return (
    <LayoutContainer title="SurveyForm">
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className="page-header-icon fa fa-flask"></i>
          {isEdit ? "Edit Survey" : "Add Survey"}
        </h2>
        <PageHeader buttons={buttons} />
      </div>
      <div className="mx-4">
        <form onSubmit={handleSubmit}>
          <div className="d-flex flex-column font-12" style={{ gap: "56px" }}>
            <div className="height-50px">
              <InputField
                name="name"
                label="Name"
                type="text"
                value={surveyName}
                placeholder="Name"
                minLength={1}
                maxLength={50}
                required={true}
                onChangeInput={handleSurveyNameChange}
              />
            </div>

            {/* <CustomDropdown
              currentValue={currentValue}
              menuItems={surveyTypes}
              onClick={handleDropdownChange}
              label="Survey Type"
              menuItemKey="name"
              type="surveyType"
              required={true}
              searchable={false}
            /> */}
            
            <div>
            <label htmlFor="surveyType" className="mb-1 weight-500">Survey Type <span className="text-danger">*</span></label>
                  <Select
                    id="surveyType"
                    styles={customSingleSelectStyles}  
                    options={surveyTypes}
                    value={currentValue}
                    onChange={handleDropdownChange}
                    placeholder="Select Survey Type"
                    isDisabled={isEdit}
                  />
              </div>

            {surveyInfo.type === "Url" && (
              <div className="height-50px">
                <InputField
                  name="url"
                  label="Survey URL"
                  type="text"
                  value={surveyUrl}
                  placeholder="Survey URL"
                  minLength={3}
                  // maxLength={300}
                  required={true}
                  onChangeInput={handleSurveyURLChange}
                />
              </div>
            )}

            {/* <div >
              <label htmlFor="groups" className="weight-500">
                Select Group <span className="text-danger">*</span>
              </label>
             
               <Select
                isMulti
                key={menuKey}
                styles={customStyles}
                closeMenuOnSelect={false}
                // menuIsOpen={menuIsOpen}
                // onMenuClose={() => setMenuIsOpen(true)}
                name="groups"
                id="groups"
                options={allOptions}
                onChange={handleSelectChange}
                placeholder="Select Groups"
                value={selectedValue}
              />
              {groupError && (
                <p className="error-text font-12 mt-2">{groupError}</p>
              )}
            </div> */}
 <div>
        <label htmlFor="dropdownChoice" className="weight-500">
          Select Option <span className="text-danger">*</span>
        </label>
        <select
          id="dropdownChoice"
          name="dropdownChoice"
          value={dropdownChoice}
          onChange={handleDropdownChoiceChange}
          className="form-control"
        >
          <option value="0">All Employee</option>
          <option value="1">Group</option>
        </select>
      </div>

      {/* Conditionally render the Select Group dropdown */}
      {dropdownChoice === "1" && (
        <div>
          <label htmlFor="groups" className="weight-500">
            Select Group <span className="text-danger">*</span>
          </label>
          <Select
        isMulti
        styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }} // Optional styling
        closeMenuOnSelect={false}
        name="groups"
        id="groups"
        options={allOptions}
        onChange={handleSelectChange}
        placeholder="Select Groups"
        value={selectedValue}
      />
          {groupError && (
            <p className="error-text font-12 mt-2">{groupError}</p>
          )}
        </div>
      )}
            <div className="height-50px">
              {/* <CustomDatePicker
          label="Close Date"
          name="closeDate"
          required={true}
          dateFormat={"dd-MM-yyyy"}
          onChange={handleDateChange}
          defaultDate={selectedDate}
          className="date-picker"
          /> */}
              <div>
                <label className="mb-1 weight-500">
                  Select Close Date and Time{" "}
                  <span className="text-danger">*</span>
                </label>
                <DatePicker
                  selected={selectedDate}
                  onChange={handleDateTimeChange}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={5}
                  minDate={new Date()}
                  minTime={
                    // selectedDate &&
                    // selectedDate.toDateString() === new Date().toDateString()
                    //   ? new Date(0, 0, 0, new Date().getHours(), new Date().getMinutes())
                    //   : new Date(0, 0, 0, 0, 0)
                    selectedDate === null || selectedDate.toDateString() === new Date().toDateString()
                  ? new Date(0, 0, 0, new Date().getHours(), new Date().getMinutes()) 
                  : new Date(0, 0, 0, 0, 0) 
                  }
                  // minTime={new Date(0, 0, 0, new Date().getHours(), new Date().getMinutes())}
                  maxTime={new Date(new Date().setHours(23, 59, 59))}
                  // readOnly
                  dateFormat="dd-MM-yyyy HH:mm:ss"
                  placeholderText="Select Date and Time"
                  className={`mf-admin-inputfield`}
                  showMonthDropdown 
                  showYearDropdown 
                  dropdownMode="select"
                  onKeyDown={(e:any)=> {e.preventDefault()}}
                  // required={true}
                  isClearable={true}
                />
                 { dobError && (<p className="error-text font-12 mt-1">{dobError}</p>)}
              </div>
            </div>

            <div>
              <TextArea
                label="Description"
                name="description"
                value={surveyInfo.description}
                placeholder="Enter Description"
                required={true}
                minLength={10}
                maxLength={100}
                onChangeInput={handleDescriptionChange}
                showCount={true}
              />
            </div>

            <div>
              <span className="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  name="is_priority"
                  id="is_priority"
                  checked={isPriority}
                  onChange={handleCheckBoxClick}
                />
                <label htmlFor="is_priority" className="weight-500">Is Priority</label>
              </span>
            </div>

            <div className="upload-information mb-4">
              <p className="font-14 mb-4">
                Uploads must be JPG / JPEG / PNG{" "}
                <span className="text-danger">*</span>
              </p>
              <div className="mb-2">
                <div className="upload-image-wrapper d-flex flex-column">
                  {folderImage.src && (
                    <>
                      <span
                        className="remove-image-btn font-14 cursor-pointer"
                        onClick={removeImage}
                      >
                        Remove
                      </span>
                      <img
                        src={folderImage.src}
                        alt="video-challenge-image"
                        width={150}
                      />
                    </>
                  )}
                </div>
              </div>
              <label htmlFor="photo">
                <div className="upload-btn-wrapper font-14 d-flex align-items-center justify-content-center gap-1">
                  <i className="fa-regular fa-image"></i>
                  <span>
                    {folderImage.src
                      ? "Change Photo"
                      : "Upload Survey Cover Image"}
                  </span>
                </div>
              </label>
              {/* <InputField
                type="file"
                name="photo"
                id="photo"
                value={""}
                className="d-none"
                onChangeInput={handleCoverImageChange}
              /> */}
              <input type="file" name="photo" id="photo"className="d-none" accept=".jpg, .png, .jpeg"
              onChange={handleCoverImageChange}
              />
            </div>
          </div>
          <div className="addpeople-btn-bottom d-flex flex-column-reverse flex-md-row align-items-md-center justify-content-md-center gap-3 my-5">
            <CustomButton theme="red" size="md" onClick={handleCancel}>
              Cancel
            </CustomButton>
            <CustomButton theme="yellow" size="md" type="submit">
              Submit
            </CustomButton>
          </div>
        </form>
      </div>
      {/* Cropping Modal */}
      {folderImage.value && (
        <CroppingModal
          show={showCroppingModal}
          handleClose={() => setShowCroppingModal(false)}
          // handleClose={handleCancelCrop}
          image={folderImage.src}
          onCrop={handleCrop}
          onCancel={handleCancelCrop}
        />
      )}
    </LayoutContainer>
  );
};

export default SurveyForm;
